import React from "react"

import { FileDropZone } from "@coval/ui"
import { AlertCircle, Braces } from "lucide-react"

interface TracesUploadSectionProps {
  tracesFile: File | null
  onTracesFileChange: (file: File | null) => void
  tracesError: string
}

export function TracesUploadSection({
  tracesFile,
  onTracesFileChange,
  tracesError,
}: TracesUploadSectionProps) {
  return (
    <div className="space-y-2">
      <FileDropZone
        file={tracesFile}
        accept=".json"
        label="OpenTelemetry Traces file"
        fileIcon={<Braces />}
        showChangeButton={false}
        onFileChange={onTracesFileChange}
        className="py-5"
      />

      {tracesError && (
        <div className="flex items-center gap-2 text-sm text-coval-danger-text">
          <AlertCircle className="w-3.5 h-3.5 shrink-0" />
          {tracesError}
        </div>
      )}
    </div>
  )
}
